export default {
    VOICE_RECOGNITION_EMPTY: "Не удалось распознать текст",
    VOICE_RECOGNITION_ERROR: "Произошла ошибка при распознавании текста",
    SAVE_FILE_ERROR: "Не удалось сохранить файл"
};
